export enum Language {
  ENGLISH = "English",
  KOREAN = "Korean",
  SPANISH = "Spanish",
  FRENCH = "French",
  RUSSIAN = "Russian",
  CHINESE = "Chinese",
  ARABIC = "Arabic",
}
